type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div className={centered ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label font-medium tracking-[0.18em] uppercase text-primary-700">
        <span className="w-6 h-px bg-accent-500" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 md:mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      ) : null}
    </div>
  );
}